// extracted by mini-css-extract-plugin
export default {"use":"Use_use__BCtz2","use_card":"Use_use_card__KqhwT","header":"Use_header__kotMg","info":"Use_info__z-ZeL"};